import templateUrl from 'emun.customer/customer-list-cards.htm'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import activityConfig from 'emun.activity/activity.config'

let component = {
    bindings: {
    },
    require: {
        container: '^customerContainer',
        list: '^customerList'
    },
	controller() {
		const $ctrl = this;
		basicController(this);
		$ctrl.activityConfig = activityConfig;
        //this.query = this.list.query;
    },
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

export default component;